import { createSelector } from 'reselect';
import MrdMonitoringReportsColumns from '../../../component/MrdMonitoringReportsColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.MRD_MONITORING_REPORT_ALL_ISSUES.isLoading;
export const getData = TableDefinitions.MRD_MONITORING_REPORT_ALL_ISSUES.getDataFunction();
export const getColumns = createSelector(getData, MrdMonitoringReportsColumns);
